// import { HiCamera } from "react-icons/hi"
// import {  Link } from "react-router-dom";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";
export default function ApplicationForm() {
  
  const [isOpen, setIsOpen] = useState(false);
  const [isOpen2, setIsOpen2] = useState(false);
  const [ownerType, setOwnertype] = useState(true);
  let [loadingBtn, setLoadingBtn] = useState(false);
  const [memberDetails, setMemberdetails] = useState(true);
  const [memberEmail, setMemberemail] = useState(true);
  let [image, setImage] = useState("");
  let [sendImage, setSendImage] = useState();
  const navigate = useNavigate();

  let imageHandler = (e) => {
    const reader = new FileReader();
    reader.onload = () => {
      if (reader.readyState === 2) {
        setImage(reader.result);
      }
      setSendImage(e.target.files[0])
    }
    reader.readAsDataURL(e.target.files[0])
  };

  useEffect(() => {
    MemberDetails()
  }, []);

  const MemberDetails = () => {
    let url = process.env.REACT_APP_BASEURL + `user-detail/`
    const config = {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-type": "application/json",
            "Authorization": 'Bearer ' + localStorage.getItem("access_token")
        }
    };
   
    axios.get(url, config)
        .then(res => {
          setMemberdetails(res.data.message);
          setMemberemail(res.data);
          console.log(res.data)
        }
        ).catch(err => {
            console.log(err)
        })
  }


  let [addData, setAddData] = useState({
    firstname: '', fathername: '',
    paddressline1: '',paddressline2: '',
    paddressline3: '',pcity: '',
    pstate: '', pcountry: '',
    ppostcode: '', caddressline1: '',
    caddressline2: '', caddressline3: '',
    ccity: '', cstate: '',
    ccountry: '', cpostcode: '',
    phonenumber: '', dob: '',
    pannumber: '', email: '',
    unitnumber: '', occupation: '',
    date: '', place: '', sign_proof: '',

    jo_firstname: '', jo_fathername: '',
    jo_paddressline1: '', jo_paddressline2: '',
    jo_paddressline3: '', jo_pcity: '',
    jo_pstate: '', jo_pcountry: '',
    jo_ppostcode: '', jo_caddressline1: '',
    jo_caddressline2: '', jo_caddressline3: '',
    jo_ccity: '', jo_cstate: '',
    jo_ccountry: '', jo_cpostcode: '',
    jo_phonenumber: '', jo_dob: '',
    jo_email: '', jo_occupation: '',

    sjo_firstname: '', sjo_fathername: '',
    sjo_paddressline1: '', sjo_paddressline2: '',
    sjo_paddressline3: '', sjo_pcity: '',
    sjo_pstate: '', sjo_pcountry: '',
    sjo_ppostcode: '', sjo_caddressline1: '',
    sjo_caddressline2: '', sjo_caddressline3: '',
    sjo_ccity: '', sjo_cstate: '',
    sjo_ccountry: '', sjo_cpostcode: '',
    sjo_phonenumber: '', sjo_dob: '',
    sjo_email: '', sjo_occupation: '',

  });

  let [checkFirstName, setCheckFirstName] = useState('');
  let [checkFatherName, setCheckFatherName] = useState('');
  let [checkPaddressline1, setCheckPaddressline1] = useState('');
  let [checkPaddressline2, setCheckPaddressline2] = useState('');
  let [checkPaddressline3, setCheckPaddressline3] = useState('');

  let [checkPcity, setCheckPcity] = useState('');
  let [checkPstate, setCheckPstate] = useState('');
  let [checkPcountry, setCheckPcountry] = useState('');
  let [checkPpostcode, setCheckPpostcode] = useState('');
  let [checkCaddressline1, setCheckCaddressline1] = useState('');
  let [checkCaddressline2, setCheckCaddressline2] = useState('');
  let [checkCaddressline3, setCheckCaddressline3] = useState('');

  let [checkCcity, setCheckCcity] = useState('');
  let [checkCstate, setCheckCstate] = useState('');
  let [checkCcountry, setCheckCcountry] = useState('');
  let [checkCpostcode, setCheckCpostcode] = useState('');
  let [checkPhonenumber, setCheckPhonenumber] = useState('');
  let [checkDob, setCheckDob] = useState('');
  let [checkPannumber, setCheckPannumber] = useState('');
  let [checkEmail, setCheckEmail] = useState('');
  let [checkUnitnumber, setCheckUnitnumber] = useState('');
  let [checkOccupation, setCheckOccupation] = useState('');

  let [checkJO_FirstName, setCheckJO_FirstName] = useState('');
  let [checkJO_FatherName, setCheckJO_FatherName] = useState('');
  let [checkJO_Paddressline1, setCheckJO_Paddressline1] = useState('');
  let [checkJO_Paddressline2, setCheckJO_Paddressline2] = useState('');
  let [checkJO_Paddressline3, setCheckJO_Paddressline3] = useState('');

  let [checkJO_Pcity, setCheckJO_Pcity] = useState('');
  let [checkJO_Pstate, setCheckJO_Pstate] = useState('');
  let [checkJO_Pcountry, setCheckJO_Pcountry] = useState('');
  let [checkJO_Ppostcode, setCheckJO_Ppostcode] = useState('');
  let [checkJO_Caddressline1, setCheckJO_Caddressline1] = useState('');
  let [checkJO_Caddressline2, setCheckJO_Caddressline2] = useState('');
  let [checkJO_Caddressline3, setCheckJO_Caddressline3] = useState('');

  let [checkJO_Ccity, setCheckJO_Ccity] = useState('');
  let [checkJO_Cstate, setCheckJO_Cstate] = useState('');
  let [checkJO_Ccountry, setCheckJO_Ccountry] = useState('');
  let [checkJO_Cpostcode, setCheckJO_Cpostcode] = useState('');
  let [checkJO_Phonenumber, setCheckJO_Phonenumber] = useState('');
  let [checkJO_Dob, setCheckJO_Dob] = useState('');
  let [checkJO_Email, setCheckJO_Email] = useState('');
  let [checkJO_Occupation, setCheckJO_Occupation] = useState('');

  let [checkSJO_FirstName, setCheckSJO_FirstName] = useState('');
  let [checkSJO_FatherName, setCheckSJO_FatherName] = useState('');
  let [checkSJO_Paddressline1, setCheckSJO_Paddressline1] = useState('');
  let [checkSJO_Paddressline2, setCheckSJO_Paddressline2] = useState('');
  let [checkSJO_Paddressline3, setCheckSJO_Paddressline3] = useState('');

  let [checkSJO_Pcity, setCheckSJO_Pcity] = useState('');
  let [checkSJO_Pstate, setCheckSJO_Pstate] = useState('');
  let [checkSJO_Pcountry, setCheckSJO_Pcountry] = useState('');
  let [checkSJO_Ppostcode, setCheckSJO_Ppostcode] = useState('');
  let [checkSJO_Caddressline1, setCheckSJO_Caddressline1] = useState('');
  let [checkSJO_Caddressline2, setCheckSJO_Caddressline2] = useState('');
  let [checkSJO_Caddressline3, setCheckSJO_Caddressline3] = useState('');

  let [checkSJO_Ccity, setCheckSJO_Ccity] = useState('');
  let [checkSJO_Cstate, setCheckSJO_Cstate] = useState('');
  let [checkSJO_Ccountry, setCheckSJO_Ccountry] = useState('');
  let [checkSJO_Cpostcode, setCheckSJO_Cpostcode] = useState('');
  let [checkSJO_Phonenumber, setCheckSJO_Phonenumber] = useState('');
  let [checkSJO_Dob, setCheckSJO_Dob] = useState('');
  let [checkSJO_Email, setCheckSJO_Email] = useState('');
  let [checkSJO_Occupation, setCheckSJO_Occupation] = useState('');
  
  let [checkDate, setCheckDate] = useState('');
  let [checkPlace, setCheckPlace] = useState('');
  let [checkSignature, setCheckSignature] = useState(false);
  let [checkSignatureerror, setCheckSignatureerror] = useState('');

// let changeFirstName = (e) => {
//   setAddData({ ...addData, firstname: e.target.value });
//   if (e.target.value.trim() === '') { 
//       setCheckFirstName('First Name is required');
//   } else {
//       setCheckFirstName('');
//   }
// }
  
let changeFatherName = (e) => {
  setAddData({ ...addData, fathername: e.target.value });
  if (e.target.value.trim() === '') {
      setCheckFatherName('Father’s / Husband’s Name is required');
  } else {
      setCheckFatherName('');
  }
}
  
let changePaddress = (e) => {
  setAddData({ ...addData, paddressline1: e.target.value });
  if (e.target.value.trim() === '') {
      setCheckPaddressline1('Address is required');
  } else {
      setCheckPaddressline1('');
  }
  }

  let changePcity = (e) => {
    setAddData({ ...addData, pcity : e.target.value });
    if (e.target.value.trim() === '') {
        setCheckPcity('City Name is required');
    } else {
        setCheckPcity('');
    }
  }

  let changePstate = (e) => {
    setAddData({ ...addData, pstate: e.target.value });
    if (e.target.value.trim() === '') {
        setCheckPstate('State Name is required');
    } else {
        setCheckPstate('');
    }
  }

  let changePcountry = (e) => {
    setAddData({ ...addData, pcountry: e.target.value });
    if (e.target.value.trim() === '') {
        setCheckPcountry('Country Name is required');
    } else {
        setCheckPcountry('');
    }
  }

  let changePpostcode = (e) => {
    setAddData({ ...addData, ppostcode: e.target.value });
    if (e.target.value.trim() === '') {
        setCheckPpostcode('Postcode is required');
    } else {
        setCheckPpostcode(''); 
    }
  }

  let changeCaddress = (e) => {
    setAddData({ ...addData, caddressline1: e.target.value });
    if (e.target.value.trim() === '') {
        setCheckCaddressline1('Address is required');
    } else {
        setCheckCaddressline1('');
    }
    }
  
    let changeCcity = (e) => {
      setAddData({ ...addData, ccity : e.target.value });
      if (e.target.value.trim() === '') {
          setCheckCcity('City Name is required');
      } else {
          setCheckCcity('');
      }
    }
  
    let changeCstate = (e) => {
      setAddData({ ...addData, cstate: e.target.value });
      if (e.target.value.trim() === '') {
          setCheckCstate('State Name is required');
      } else {
          setCheckCstate('');
      }
    }
  
    let changeCcountry = (e) => {
      setAddData({ ...addData, ccountry: e.target.value });
      if (e.target.value.trim() === '') {
          setCheckCcountry('Country Name is required');
      } else {
          setCheckCcountry('');
      }
    }
  
    let changeCpostcode = (e) => {
      setAddData({ ...addData, cpostcode: e.target.value });
      if (e.target.value.trim() === '') {
          setCheckCpostcode('Postcode is required');
      } else {
          setCheckCpostcode('');
      }
  }
  
  // let changePhonenumber = (e) => {
  //   setAddData({ ...addData, phonenumber: e.target.value });
  //   if (e.target.value.length !== 10 || Number(e.target.value) < 6000000000) {
  //       setCheckPhonenumber('Mobile Number is required');
  //   } else {
  //       setCheckPhonenumber('');
  //   }
  // }

 let changedob = (e) => {
        setAddData({ ...addData, dob: e.target.value });
        if (e.target.value.trim() === ''){
            setCheckDob('Date of birth is required'); } 
        else{
            setCheckDob('');
        }
  }
  
  let changePannumber = (e) => {
    setAddData({ ...addData, pannumber: e.target.value });
    if (e.target.value.trim() === ''){
        setCheckPannumber('Pan Number is required'); } 
    else{
        setCheckPannumber('');
    }
  }

  // let changeEmail = (e) => {
  //   setAddData({ ...addData, email: e.target.value });
  //   if (!(RegExp(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,15}/g).test(e.target.value))){
  //       setCheckEmail('Email is not valid or required'); } 
  //   else{
  //       setCheckEmail('');
  //   }
  // }
  
  // let changeUnitnumber = (e) => {
  //   setAddData({ ...addData, unitnumber: e.target.value });
  //   if (e.target.value.trim() === ''){
  //       setCheckUnitnumber('Unit Number is required'); } 
  //   else{
  //       setCheckUnitnumber('');
  //   }
  // }

  let changeOccupation = (e) => {
    setAddData({ ...addData, occupation: e.target.value });
    if (e.target.value.trim() === ''){
        setCheckOccupation('Occupation is required'); } 
    else{
        setCheckOccupation('');
    }
  }


  let changeJO_FirstName = (e) => {
    setAddData({ ...addData, jo_firstname: e.target.value });
    if (e.target.value.trim() === '') {
        setCheckJO_FirstName('First Name is required');
    } else {
        setCheckJO_FirstName('');
    }
  }
    
  let changeJO_FatherName = (e) => {
    setAddData({ ...addData, jo_fathername: e.target.value });
    if (e.target.value.trim() === '') {
        setCheckJO_FatherName('Father’s / Husband’s Name is required');
    } else {
        setCheckJO_FatherName('');
    }
  }
    
  let changeJO_Paddress = (e) => {
    setAddData({ ...addData, jo_paddressline1: e.target.value });
    if (e.target.value.trim() === '') {
        setCheckJO_Paddressline1('Address is required');
    } else {
        setCheckJO_Paddressline1('');
    }
    }
  
    let changeJO_Pcity = (e) => {
      setAddData({ ...addData, jo_pcity : e.target.value });
      if (e.target.value.trim() === '') {
          setCheckJO_Pcity('City Name is required');
      } else {
          setCheckJO_Pcity('');
      }
    }
  
    let changeJO_Pstate = (e) => {
      setAddData({ ...addData, jo_pstate: e.target.value });
      if (e.target.value.trim() === '') {
          setCheckJO_Pstate('State Name is required');
      } else {
          setCheckJO_Pstate('');
      }
    }
  
    let changeJO_Pcountry = (e) => {
      setAddData({ ...addData, jo_pcountry: e.target.value });
      if (e.target.value.trim() === '') {
          setCheckJO_Pcountry('Country Name is required');
      } else {
          setCheckJO_Pcountry('');
      }
    }
  
    let changeJO_Ppostcode = (e) => {
      setAddData({ ...addData, jo_ppostcode: e.target.value });
      if (e.target.value.trim() === '') {
          setCheckJO_Ppostcode('Postcode is required');
      } else {
          setCheckJO_Ppostcode('');
      }
    }
  
    let changeJO_Caddress = (e) => {
      setAddData({ ...addData, jo_caddressline1: e.target.value });
      if (e.target.value.trim() === '') {
          setCheckJO_Caddressline1('Address is required');
      } else {
          setCheckJO_Caddressline1('');
      }
      }
    
      let changeJO_Ccity = (e) => {
        setAddData({ ...addData, jo_ccity : e.target.value });
        if (e.target.value.trim() === '') {
            setCheckJO_Ccity('City Name is required');
        } else {
            setCheckJO_Ccity('');
        }
      }
    
      let changeJO_Cstate = (e) => {
        setAddData({ ...addData, jo_cstate: e.target.value });
        if (e.target.value.trim() === '') {
            setCheckJO_Cstate('State Name is required');
        } else {
            setCheckJO_Cstate('');
        }
      }
    
      let changeJO_Ccountry = (e) => {
        setAddData({ ...addData, jo_ccountry: e.target.value });
        if (e.target.value.trim() === '') {
            setCheckJO_Ccountry('Country Name is required');
        } else {
            setCheckJO_Ccountry('');
        }
      }
    
      let changeJO_Cpostcode = (e) => {
        setAddData({ ...addData, jo_cpostcode: e.target.value });
        if (e.target.value.trim() === '') {
            setCheckJO_Cpostcode('Postcode is required');
        } else {
            setCheckJO_Cpostcode('');
        }
    }
    
    let changeJO_Phonenumber = (e) => {
      setAddData({ ...addData, jo_phonenumber: e.target.value });
      if (e.target.value.length !== 10 || Number(e.target.value) < 6000000000) {
          setCheckJO_Phonenumber('Mobile Number is required');
      } else {
          setCheckJO_Phonenumber('');
      }
    }
  
   let changeJO_dob = (e) => {
          setAddData({ ...addData, jo_dob: e.target.value });
          if (e.target.value.trim() === ''){
              setCheckJO_Dob('Date of birth is required'); } 
          else{
              setCheckJO_Dob('');
          }
    }
  
    let changeJO_Email = (e) => {
      setAddData({ ...addData, jo_email: e.target.value });
      if (!(RegExp(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,15}/g).test(e.target.value))){
          setCheckJO_Email('Email is not valid or required'); } 
      else{
          setCheckJO_Email('');
      }
    }
  
    let changeJO_Occupation = (e) => {
      setAddData({ ...addData, jo_occupation: e.target.value });
      if (e.target.value.trim() === ''){
          setCheckJO_Occupation('Occupation is required'); } 
      else{
          setCheckJO_Occupation('');
      }
  }
  

  let changeSJO_FirstName = (e) => {
    setAddData({ ...addData, sjo_firstname: e.target.value });
    if (e.target.value.trim() === '') {
        setCheckSJO_FirstName('First Name is required');
    } else {
        setCheckSJO_FirstName('');
    }
  }
    
  let changeSJO_FatherName = (e) => {
    setAddData({ ...addData, sjo_fathername: e.target.value });
    if (e.target.value.trim() === '') {
        setCheckSJO_FatherName('Father’s / Husband’s Name is required');
    } else {
        setCheckSJO_FatherName('');
    }
  }
    
  let changeSJO_Paddress = (e) => {
    setAddData({ ...addData, sjo_paddressline1: e.target.value });
    if (e.target.value.trim() === '') {
        setCheckSJO_Paddressline1('Address is required');
    } else {
        setCheckSJO_Paddressline1('');
    }
    }
  
    let changeSJO_Pcity = (e) => {
      setAddData({ ...addData, sjo_pcity : e.target.value });
      if (e.target.value.trim() === '') {
          setCheckSJO_Pcity('City Name is required');
      } else {
          setCheckSJO_Pcity('');
      }
    }
  
    let changeSJO_Pstate = (e) => {
      setAddData({ ...addData, sjo_pstate: e.target.value });
      if (e.target.value.trim() === '') {
          setCheckSJO_Pstate('State Name is required');
      } else {
          setCheckSJO_Pstate('');
      }
    }
  
    let changeSJO_Pcountry = (e) => {
      setAddData({ ...addData, sjo_pcountry: e.target.value });
      if (e.target.value.trim() === '') {
          setCheckSJO_Pcountry('Country Name is required');
      } else {
          setCheckSJO_Pcountry('');
      }
    }
  
    let changeSJO_Ppostcode = (e) => {
      setAddData({ ...addData, sjo_ppostcode: e.target.value });
      if (e.target.value.trim() === '') {
          setCheckSJO_Ppostcode('Postcode is required');
      } else {
          setCheckSJO_Ppostcode('');
      }
    }
  
    let changeSJO_Caddress = (e) => {
      setAddData({ ...addData, sjo_caddressline1: e.target.value });
      if (e.target.value.trim() === '') {
          setCheckSJO_Caddressline1('Address is required');
      } else {
          setCheckSJO_Caddressline1('');
      }
      }
    
      let changeSJO_Ccity = (e) => {
        setAddData({ ...addData, sjo_ccity : e.target.value });
        if (e.target.value.trim() === '') {
            setCheckSJO_Ccity('City Name is required');
        } else {
            setCheckSJO_Ccity('');
        }
      }
    
      let changeSJO_Cstate = (e) => {
        setAddData({ ...addData, sjo_cstate: e.target.value });
        if (e.target.value.trim() === '') {
            setCheckSJO_Cstate('State Name is required');
        } else {
            setCheckSJO_Cstate('');
        }
      }
    
      let changeSJO_Ccountry = (e) => {
        setAddData({ ...addData, sjo_ccountry: e.target.value });
        if (e.target.value.trim() === '') {
            setCheckSJO_Ccountry('Country Name is required');
        } else {
            setCheckSJO_Ccountry('');
        }
      }
    
      let changeSJO_Cpostcode = (e) => {
        setAddData({ ...addData, sjo_cpostcode: e.target.value });
        if (e.target.value.trim() === '') {
            setCheckSJO_Cpostcode('Postcode is required');
        } else {
            setCheckSJO_Cpostcode('');
        }
    }
    
    let changeSJO_Phonenumber = (e) => {
      setAddData({ ...addData, sjo_phonenumber: e.target.value });
      if (e.target.value.length !== 10 || Number(e.target.value) < 6000000000) {
          setCheckSJO_Phonenumber('Mobile Number is required');
      } else {
          setCheckSJO_Phonenumber('');
      }
    }
  
   let changeSJO_dob = (e) => {
          setAddData({ ...addData, sjo_dob: e.target.value });
          if (e.target.value.trim() === ''){
              setCheckSJO_Dob('Date of birth is required'); } 
          else{
              setCheckSJO_Dob('');
          }
    }
  
    let changeSJO_Email = (e) => {
      setAddData({ ...addData, sjo_email: e.target.value });
      if (!(RegExp(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,15}/g).test(e.target.value))){
          setCheckSJO_Email('Email is not valid or required'); } 
      else{
          setCheckSJO_Email('');
      }
    }
  
    let changeSJO_Occupation = (e) => {
      setAddData({ ...addData, sjo_occupation: e.target.value });
      if (e.target.value.trim() === ''){
          setCheckSJO_Occupation('Occupation is required'); } 
      else{
          setCheckSJO_Occupation('');
      }
  }

  // let changeSignature = (e) => {
  //   e.preventDefault();
  //   setAddData({ ...addData, sign_proof: e.target.files });console.log(changeSignature)
  //   if (e.target.files[0].type === 'application/pdf') {
  //     setCheckSignature(true); setCheckSignatureerror('');
  //   } else {
  //     setCheckSignature(false); setCheckSignatureerror('Signature is required or invalid');
  //   }
  // }
  

  let changeDate = (e) => {
    setAddData({ ...addData, date: e.target.value });
    if (e.target.value.trim() === ''){
        setCheckDate('Date is required'); } 
    else{
        setCheckDate('');
    }
}

let changePlace = (e) => {
  setAddData({ ...addData, place: e.target.value });
  if (e.target.value.trim() === ''){
      setCheckPlace('Place is required'); } 
  else{
      setCheckPlace('');
  }
  }
  


  let save = (e) => {
    e.preventDefault();
    let error = 0;
    // let me = "";
    // let ee = "";

    // if (addData.firstname.trim() === '') {
    //   error = 1;
    //   setCheckFirstName('First name is required');
    // }
    // else {
    //   setCheckFirstName('');
    // }

    if (addData.fathername.trim() === '') {
      error = 1;
      setCheckFatherName('Father name is required');
    }
    else {
      setCheckFatherName('');
    }

    if (addData.paddressline1.trim() === '') {
      error = 1;
      setCheckPaddressline1('Parmenent address is required');
    }
    else {
      setCheckPaddressline1('');
    }

    if (addData.pcity.trim() === '') {
      error = 1;
      setCheckPcity('Parmenent city is required');
    }
    else {
      setCheckPcity('');
    }

    if (addData.pstate.trim() === '') {
      error = 1;
      setCheckPstate('Parmenent state is required');
    }
    else {
      setCheckPstate('');
    }

    if (addData.pcountry.trim() === '') {
      error = 1;
      setCheckPcountry('Parmenent country is required');
    }
    else {
      setCheckPcountry('');
    }

    if (addData.ppostcode.trim() === '') {
      error = 1;
      setCheckPpostcode('Parmenent postcode is required');
    }
    else {
      setCheckPpostcode('');
    }


    if (addData.caddressline1.trim() === '') {
      error = 1;
      setCheckCaddressline1('Correspondence address is required');
    }
    else {
      setCheckCaddressline1('');
    }

    if (addData.ccity.trim() === '') {
      error = 1;
      setCheckCcity('Correspondence city is required');
    }
    else {
      setCheckCcity('');
    }

    if (addData.cstate.trim() === '') {
      error = 1;
      setCheckCstate('Correspondence state is required');
    }
    else {
      setCheckCstate('');
    }

    if (addData.ccountry.trim() === '') {
      error = 1;
      setCheckCcountry('Correspondence country is required');
    }
    else {
      setCheckCcountry('');
    }

    if (addData.cpostcode.trim() === '') {
      error = 1;
      setCheckCpostcode('Correspondence postcode is required');
    }
    else {
      setCheckCpostcode('');
    }

    // if (Number(addData.phonenumber) <= 6000000000 || Number(addData.phonenumber) >= 9999999999) {
    //   error = 1;
    //   setCheckPhonenumber('Mobile number is required or invalid');
    // } else {
    //   setCheckPhonenumber('');
    // }

    if (addData.dob.trim() === '') {
      error = 1;
      setCheckDob('Date of birth is required');
    }
    else {
      setCheckDob('');
    }

    if (addData.pannumber.trim() === '') {
      error = 1;
      setCheckPannumber('Pan number is required');
    }
    else {
      setCheckPannumber('');
    }

    // if (addData.email.trim() === '') {
    //   error = 1;
    //   setCheckEmail('Email is required or invalid');
    // } else {
    //   setCheckEmail('');
    // }

    // if (addData.unitnumber.trim() === '') {
    //   error = 1;
    //   setCheckUnitnumber('Unit number is required');
    // }
    // else {
    //   setCheckUnitnumber('');
    // }

    if (addData.occupation.trim() === '') {
      error = 1;
      setCheckOccupation('Occupation is required');
    }
    else {
      setCheckOccupation('');
    }

    // if (checkSignature === false ) {
    //   error = 1;
    //   setCheckSignatureerror('Signature is required or invalid');
    // }
    // else {
    //   setCheckSignatureerror('');
    // }

    if (addData.place.trim() === '') {
      error = 1;
      setCheckPlace('Place is required');
    }
    else {
      setCheckPlace('');
    }

    if (addData.date.trim() === '') {
      error = 1;
      setCheckDate('Date is required');
    }
    else {
      setCheckDate('');
    }

    
    if (ownerType === false) {

      if (isOpen === true) {
      if (addData.jo_firstname.trim() === '') {
        error = 1;
        setCheckJO_FirstName('First name is required');
      }
      else {
        setCheckJO_FirstName('');
      }

      if (addData.jo_fathername.trim() === '') {
        error = 1;
        setCheckJO_FatherName('Father name is required');
      }
      else {
        setCheckJO_FatherName('');
      }

      if (addData.jo_paddressline1.trim() === '') {
        error = 1;
        setCheckJO_Paddressline1('Parmenent address is required');
      }
      else {
        setCheckJO_Paddressline1('');
      }

      if (addData.jo_pcity.trim() === '') {
        error = 1;
        setCheckJO_Pcity('Parmenent city is required');
      }
      else {
        setCheckJO_Pcity('');
      }

      if (addData.jo_pstate.trim() === '') {
        error = 1;
        setCheckJO_Pstate('Parmenent state is required');
      }
      else {
        setCheckJO_Pstate('');
      }

      if (addData.jo_pcountry.trim() === '') {
        error = 1;
        setCheckJO_Pcountry('Parmenent country is required');
      }
      else {
        setCheckJO_Pcountry('');
      }

      if (addData.jo_ppostcode.trim() === '') {
        error = 1;
        setCheckJO_Ppostcode('Parmenent postcode is required');
      }
      else {
        setCheckJO_Ppostcode('');
      }


      if (addData.jo_caddressline1.trim() === '') {
        error = 1;
        setCheckJO_Caddressline1('Correspondence address is required');
      }
      else {
        setCheckJO_Caddressline1('');
      }

      if (addData.jo_ccity.trim() === '') {
        error = 1;
        setCheckJO_Ccity('Correspondence city is required');
      }
      else {
        setCheckJO_Ccity('');
      }

      if (addData.jo_cstate.trim() === '') {
        error = 1;
        setCheckJO_Cstate('Correspondence state is required');
      }
      else {
        setCheckJO_Cstate('');
      }

      if (addData.jo_ccountry.trim() === '') {
        error = 1;
        setCheckJO_Ccountry('Correspondence country is required');
      }
      else {
        setCheckJO_Ccountry('');
      }

      if (addData.jo_cpostcode.trim() === '') {
        error = 1;
        setCheckJO_Cpostcode('Correspondence postcode is required');
      }
      else {
        setCheckJO_Cpostcode('');
      }

      if (Number(addData.jo_phonenumber) <= 6000000000 || Number(addData.jo_phonenumber) >= 9999999999) {
        error = 1;
        setCheckJO_Phonenumber('Mobile number is required or invalid');
      } else {
        setCheckJO_Phonenumber('');
      }

      if (addData.jo_dob.trim() === '') {
        error = 1;
        setCheckJO_Dob('Date of birth is required');
      }
      else {
        setCheckJO_Dob('');
      }

      if (addData.jo_email.trim() === '') {
        error = 1;
        setCheckJO_Email('Email is required or invalid');
      } else {
        setCheckJO_Email('');
      }

      if (addData.jo_occupation.trim() === '') {
        error = 1;
        setCheckJO_Occupation('Occupation is required');
      }
      else {
        setCheckJO_Occupation('');
      }
    }


if(isOpen2===true){
      if (addData.sjo_firstname.trim() === '') {
        error = 1;
        setCheckSJO_FirstName('First name is required');
      }
      else {
        setCheckSJO_FirstName('');
      }

      if (addData.sjo_fathername.trim() === '') {
        error = 1;
        setCheckSJO_FatherName('Father name is required');
      }
      else {
        setCheckSJO_FatherName('');
      }

      if (addData.sjo_paddressline1.trim() === '') {
        error = 1;
        setCheckSJO_Paddressline1('Parmenent address is required');
      }
      else {
        setCheckSJO_Paddressline1('');
      }

      if (addData.sjo_pcity.trim() === '') {
        error = 1;
        setCheckSJO_Pcity('Parmenent city is required');
      }
      else {
        setCheckSJO_Pcity('');
      }

      if (addData.sjo_pstate.trim() === '') {
        error = 1;
        setCheckSJO_Pstate('Parmenent state is required');
      }
      else {
        setCheckSJO_Pstate('');
      }

      if (addData.sjo_pcountry.trim() === '') {
        error = 1;
        setCheckSJO_Pcountry('Parmenent country is required');
      }
      else {
        setCheckSJO_Pcountry('');
      }

      if (addData.sjo_ppostcode.trim() === '') {
        error = 1;
        setCheckSJO_Ppostcode('Parmenent postcode is required');
      }
      else {
        setCheckSJO_Ppostcode('');
      }


      if (addData.sjo_caddressline1.trim() === '') {
        error = 1;
        setCheckSJO_Caddressline1('Correspondence address is required');
      }
      else {
        setCheckSJO_Caddressline1('');
      }

      if (addData.sjo_ccity.trim() === '') {
        error = 1;
        setCheckSJO_Ccity('Correspondence city is required');
      }
      else {
        setCheckSJO_Ccity('');
      }

      if (addData.sjo_cstate.trim() === '') {
        error = 1;
        setCheckSJO_Cstate('Correspondence state is required');
      }
      else {
        setCheckSJO_Cstate('');
      }

      if (addData.sjo_ccountry.trim() === '') {
        error = 1;
        setCheckSJO_Ccountry('Correspondence country is required');
      }
      else {
        setCheckSJO_Ccountry('');
      }

      if (addData.sjo_cpostcode.trim() === '') {
        error = 1;
        setCheckSJO_Cpostcode('Correspondence postcode is required');
      }
      else {
        setCheckSJO_Cpostcode('');
      }

      if (Number(addData.sjo_phonenumber) <= 6000000000 || Number(addData.sjo_phonenumber) >= 9999999999) {
        error = 1;
        setCheckSJO_Phonenumber('Mobile number is required or invalid');
      } else {
        setCheckSJO_Phonenumber('');
      }

      if (addData.sjo_dob.trim() === '') {
        error = 1;
        setCheckSJO_Dob('Date of birth is required');
      }
      else {
        setCheckSJO_Dob('');
      }

      if (addData.sjo_email.trim() === '') {
        error = 1;
        setCheckSJO_Email('Email is required or invalid');
      } else {
        setCheckSJO_Email('');
      }

      if (addData.sjo_occupation.trim() === '') {
        error = 1;
        setCheckSJO_Occupation('Occupation is required');
      }
      else {
        setCheckSJO_Occupation('');
      }
    }
    }


    
    if (error === 0) {
      setLoadingBtn(true)
      let formData = new FormData();
      let addmember = {
        father_or_husband_name: addData.fathername,

        per_add_line1: addData.paddressline1,
        per_add_line2: addData.paddressline2,
        per_add_line3: addData.paddressline3,
        per_add_city: addData.pcity,
        per_add_state: addData.pstate,
        per_add_country: addData.pcountry,
        per_add_postcode: addData.ppostcode,

        comm_add_line1: addData.caddressline1,
        comm_add_line2: addData.caddressline2,
        comm_add_line3: addData.caddressline3,
        comm_add_city: addData.ccity,
        comm_add_state: addData.cstate,
        comm_add_country: addData.ccountry,
        comm_add_postcode: addData.cpostcode,

        dob: addData.dob,
        pan_num: addData.pannumber,
        occupation: addData.occupation,

        // sign_proof: addData.sign_proof,
        sign_date: addData.date,
        sign_place: addData.place,

            "jointowners":[
            // joint owner
              {
                name: addData.jo_firstname,
                father_or_husband_name: addData.jo_fathername,

                per_add_line1: addData.jo_paddressline1, 
                per_add_line2: addData.jo_paddressline2,
                per_add_line3: addData.jo_paddressline3,
                per_add_city: addData.jo_pcity,
                per_add_state: addData.jo_pstate,
                per_add_country: addData.jo_pcountry,
                per_add_postcode: addData.jo_ppostcode,

                comm_add_line1: addData.jo_caddressline1,
                comm_add_line2: addData.jo_caddressline2,
                comm_add_line3: addData.jo_caddressline3,
                comm_add_city: addData.jo_ccity,
                comm_add_state: addData.jo_cstate,
                comm_add_country: addData.jo_ccountry,
                comm_add_postcode: addData.jo_cpostcode,
                
                dob: addData.jo_dob,
                occupation: addData.jo_occupation,
                email_id: addData.jo_email,
                phone_number: addData.jo_phonenumber,
              },
              // Second joint owner
              {
                name: addData.sjo_firstname,
                father_or_husband_name: addData.sjo_fathername,
                
                per_add_line1: addData.sjo_paddressline1,
                per_add_line2: addData.sjo_paddressline2,
                per_add_line3: addData.sjo_paddressline3,
                per_add_city: addData.sjo_pcity,
                per_add_state: addData.sjo_pstate,
                per_add_country: addData.sjo_pcountry,
                per_add_postcode: addData.sjo_ppostcode,
                
                comm_add_line1: addData.sjo_caddressline1,
                comm_add_line2: addData.sjo_caddressline2,
                comm_add_line3: addData.sjo_caddressline3,
                comm_add_city: addData.sjo_ccity,
                comm_add_state: addData.sjo_cstate,
                comm_add_country: addData.sjo_ccountry,
                comm_add_postcode: addData.sjo_cpostcode,

                dob: addData.sjo_dob,
                occupation: addData.sjo_occupation,
                email_id: addData.sjo_email,
                phone_number: addData.sjo_phonenumber,
              }]
      }
     
      let url = process.env.REACT_APP_BASEURL + "create-member/";
    
      const config = {
          headers: {
              "Access-Control-Allow-Origin": "*",
              "Content-type": "application/json",
              "Authorization": 'Bearer ' + localStorage.getItem("access_token")
          }
      };
      axios.post(url, addmember, config)
          .then((res) => {
              console.log(res)
              setLoadingBtn(false)
              toast.success("Application Form successfully sumitted!", {
                  position: toast.POSITION.TOP_RIGHT,
                  autoClose: 3000,
                  theme: "colored",
              }) 
              navigate("/paymentpage")
            }
          )
          .catch((error) => {
              setLoadingBtn(false)
              console.log(error);
              toast.error("Something went wrong.", {
                  position: toast.POSITION.TOP_RIGHT,
                  autoClose: 1000,
                  theme: "colored",
                });
          })
  }

  }

  let resetFunction = () => {
    setIsOpen(false);
    setCheckJO_FirstName('');
    setCheckJO_FatherName('');
    setCheckJO_Paddressline1('');
    setCheckJO_Paddressline2('');
    setCheckJO_Paddressline3('');

    setCheckJO_Pcity('');
    setCheckJO_Pstate('');
    setCheckJO_Pcountry('');
    setCheckJO_Ppostcode('');
    setCheckJO_Caddressline1('');
    setCheckJO_Caddressline2('');
    setCheckJO_Caddressline3('');

    setCheckJO_Ccity('');
    setCheckJO_Cstate('');
    setCheckJO_Ccountry('');
    setCheckJO_Cpostcode('');
    setCheckJO_Phonenumber('');
    setCheckJO_Dob('');
    setCheckJO_Email('');
    setCheckJO_Occupation('');
  }

  let resetFunction2 = () => {
    setIsOpen2(false);
    setCheckSJO_FirstName('');
    setCheckSJO_FatherName('');
    setCheckSJO_Paddressline1('');
    setCheckSJO_Paddressline2('');
    setCheckSJO_Paddressline3('');

    setCheckSJO_Pcity('');
    setCheckSJO_Pstate('');
    setCheckSJO_Pcountry('');
    setCheckSJO_Ppostcode('');
    setCheckSJO_Caddressline1('');
    setCheckSJO_Caddressline2('');
    setCheckSJO_Caddressline3('');

    setCheckSJO_Ccity('');
    setCheckSJO_Cstate('');
    setCheckSJO_Ccountry('');
    setCheckSJO_Cpostcode('');
    setCheckSJO_Phonenumber('');
    setCheckSJO_Dob('');
    setCheckSJO_Email('');
    setCheckSJO_Occupation('');
  }

  let addressCopy = (e) => {
    if (e.target.checked === true) {
      setAddData({ ...addData, caddressline1: addData.paddressline1, caddressline2: addData.paddressline2, caddressline3: addData.paddressline3, ccity: addData.pcity, cstate: addData.pstate, ccountry: addData.pcountry, cpostcode: addData.ppostcode });
      checkPaddressline1.trim() === '' && setCheckCaddressline1('');
      checkPaddressline2.trim() === '' && setCheckCaddressline2('');
      checkPaddressline3.trim() === '' && setCheckCaddressline3('');

      checkPcity.trim() === '' && setCheckCcity('');
      checkPstate.trim() === '' && setCheckCstate('');
      checkPcountry.trim() === '' && setCheckCcountry('');
      checkPpostcode.trim() === '' && setCheckCpostcode('');
    } else {
      setAddData({ ...addData, caddressline1: (''), caddressline2: (''), caddressline3: (''), ccity: (''), cstate: (''), ccountry: (''), cpostcode: ('') });
    }
  }

  let jop_addressCopy = (e) => {
    if (e.target.checked === true) {
      setAddData({ ...addData, jo_paddressline1: addData.paddressline1, jo_paddressline2: addData.paddressline2, jo_paddressline3: addData.paddressline3, jo_pcity: addData.pcity, jo_pstate: addData.pstate, jo_pcountry: addData.pcountry, jo_ppostcode: addData.ppostcode });
      checkPaddressline1.trim() === '' && setCheckJO_Paddressline1('');
      checkPaddressline2.trim() === '' && setCheckJO_Paddressline2('');
      checkPaddressline3.trim() === '' && setCheckJO_Paddressline3('');

      checkPcity.trim() === '' && setCheckJO_Pcity('');
      checkPstate.trim() === '' && setCheckJO_Pstate('');
      checkPcountry.trim() === '' && setCheckJO_Pcountry('');
      checkPpostcode.trim() === '' && setCheckJO_Ppostcode('');
    } else {
      setAddData({ ...addData, jo_paddressline1: (''), jo_paddressline2: (''), jo_paddressline3: (''), jo_pcity: (''), jo_pstate: (''), jo_pcountry: (''), jo_ppostcode: ('') });
    }
  }
  
  let joc_addressCopy = (e) => {
    if (e.target.checked === true) {
      setAddData({ ...addData, jo_caddressline1: addData.jo_paddressline1,  jo_caddressline2: addData.jo_paddressline2,  jo_caddressline3: addData.jo_paddressline3, jo_ccity: addData.jo_pcity, jo_cstate: addData.jo_pstate, jo_ccountry: addData.jo_pcountry, jo_cpostcode: addData.jo_ppostcode });
      checkJO_Paddressline1.trim() === '' && setCheckJO_Caddressline1('');
      checkJO_Paddressline2.trim() === '' && setCheckJO_Caddressline2('');
      checkJO_Paddressline3.trim() === '' && setCheckJO_Caddressline3('');

      checkJO_Pcity.trim() === '' && setCheckJO_Ccity('');
      checkJO_Pstate.trim() === '' && setCheckJO_Cstate('');
      checkJO_Pcountry.trim() === '' && setCheckJO_Ccountry('');
      checkJO_Ppostcode.trim() === '' && setCheckJO_Cpostcode('');
    } else {
      setAddData({ ...addData, jo_caddressline1: (''), jo_caddressline2: (''), jo_caddressline3: (''), jo_ccity: (''), jo_cstate: (''), jo_ccountry: (''), jo_cpostcode: ('') });
    }
  }
  
  let sjop_addressCopy = (e) => {
    if (e.target.checked === true) {
      setAddData({ ...addData, sjo_paddressline1: addData.paddressline1, sjo_paddressline2: addData.paddressline2, sjo_paddressline3: addData.paddressline3, sjo_pcity: addData.pcity, sjo_pstate: addData.pstate, sjo_pcountry: addData.pcountry, sjo_ppostcode: addData.ppostcode });
      checkPaddressline1.trim() === '' && setCheckSJO_Paddressline1('');
      checkPaddressline2.trim() === '' && setCheckSJO_Paddressline2('');
      checkPaddressline3.trim() === '' && setCheckSJO_Paddressline3('');

      checkPcity.trim() === '' && setCheckSJO_Pcity('');
      checkPstate.trim() === '' && setCheckSJO_Pstate('');
      checkPcountry.trim() === '' && setCheckSJO_Pcountry('');
      checkPpostcode.trim() === '' && setCheckSJO_Ppostcode('');
    } else {
      setAddData({ ...addData, sjo_paddressline1: (''), sjo_paddressline2: (''), sjo_paddressline3: (''), sjo_pcity: (''), sjo_pstate: (''), sjo_pcountry: (''), sjo_ppostcode: ('') });
    }
  }


  let sjoc_addressCopy = (e) => {
    if (e.target.checked === true) {
      setAddData({ ...addData, sjo_caddressline1: addData.sjo_paddressline1, sjo_caddressline2: addData.sjo_paddressline2, sjo_caddressline3: addData.sjo_paddressline3, sjo_ccity: addData.sjo_pcity, sjo_cstate: addData.sjo_pstate, sjo_ccountry: addData.sjo_pcountry, sjo_cpostcode: addData.sjo_ppostcode });
      checkSJO_Paddressline1.trim() === '' && setCheckSJO_Caddressline1('');
      checkSJO_Paddressline2.trim() === '' && setCheckSJO_Caddressline2('');
      checkSJO_Paddressline3.trim() === '' && setCheckSJO_Caddressline3('');

      checkSJO_Pcity.trim() === '' && setCheckSJO_Ccity('');
      checkSJO_Pstate.trim() === '' && setCheckSJO_Cstate('');
      checkSJO_Pcountry.trim() === '' && setCheckSJO_Ccountry('');
      checkSJO_Ppostcode.trim() === '' && setCheckSJO_Cpostcode('');
    } else {
      setAddData({ ...addData, sjo_caddressline1: (''), sjo_caddressline2: (''), sjo_caddressline3: (''), sjo_ccity: (''), sjo_cstate: (''), sjo_ccountry: (''), sjo_cpostcode: ('') });
    }
  }
  
  let clearField = () => {
    setAddData({ ...addData, jo_paddressline1: (''), jo_paddressline2: (''), jo_paddressline3: (''), jo_pcity: (''), jo_pstate: (''), jo_pcountry: (''), jo_ppostcode: (''), jo_caddressline1: (''), jo_ccity: (''), jo_cstate: (''), jo_ccountry: (''), jo_cpostcode: (''), sjo_paddressline1: (''), sjo_pcity: (''), sjo_pstate: (''), sjo_pcountry: (''), sjo_ppostcode: ('') , sjo_caddressline1: (''), sjo_ccity: (''), sjo_cstate: (''), sjo_ccountry: (''), sjo_cpostcode: ('')   });
  }
  
  let resetField1 = () => {
    setAddData({ ...addData, jo_paddressline1: (''),  jo_paddressline2: (''),  jo_paddressline3: (''), jo_pcity: (''), jo_pstate: (''), jo_pcountry: (''), jo_ppostcode: (''), jo_caddressline1: (''), jo_ccity: (''), jo_cstate: (''), jo_ccountry: (''), jo_cpostcode: ('')  });
  }

  let resetField2 = () => {
    setAddData({ ...addData, sjo_paddressline1: (''), sjo_paddressline2: (''), sjo_paddressline3: (''), sjo_pcity: (''), sjo_pstate: (''), sjo_pcountry: (''), sjo_ppostcode: (''), sjo_caddressline1: (''), sjo_ccity: (''), sjo_cstate: (''), sjo_ccountry: (''), sjo_cpostcode: ('')  });
  }

  return (
    <>
        <main>
          <div className='main__container'>
          <div className="container" style={{fontFamily:'sans-serif' ,fontWeight:'semibold'}}>
            <form onSubmit={save}>
                <div className="row">
                    <h4 className="text-center" style={{ fontFamily:'sans-serif', "color": "#13547A" ,"fontSize":'24px' , fontWeight: 600  }}>
                      Application Form for Membership
                    </h4>
                    <div className="text-center">
                      {
                        /* {image !== "" ? <img
                        alt="profile"
                        src={image}
                        className="img-fluid mt-3 rounded-circle "
                        style={{ width: "100px", height: "100px" }}
                        /> : */
                        <img
                          alt="profile"
                          src={require("../../InnerComponets/assets/images/profilee.jpg")}
                          className="img-fluid rounded-circle "
                          style={{ width: "100px", height: "100px" }}
                        />
                      }
                      <input type="file" accept="image/*" className='d-none' name="image-upload" id="input"
                        // onChange={imageHandler} 
                        />
                      {/* <div className="label">
                        <label className="image-upload font-bold mb-3" htmlFor="input">
                          <span className='camicon'><HiCamera /></span></label>
                      </div> */}
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm mt-3 mr-3">
                    <span className='form-text ml-3' style={{ fontFamily:'sans-serif', "color": "#000000" , fontWeight: 400 ,"fontSize":'16px' }}>Name of the Applicant*</span>
                      <input
                        style={{ borderRadius: "30px" }}
                        type="text"
                        className="form-control py-3 mt-1"
                        placeholder="Enter Applicant Name"
                        defaultValue={memberDetails.name}
                    />
                    </div>
                    <div className="col-sm mt-3 mr-3">
                    <span className='form-text ml-3' style={{ fontFamily:'sans-serif', "color": "#000000" , fontWeight: 400 ,"fontSize":'16px' }}>Father’s / Husband’s Name*</span>
                      <input
                        style={{ borderRadius: "30px" }}
                        type="text"
                        className="form-control py-3 mt-1"
                        placeholder="Enter Father’s / Husband’s Name"
                        onChange={changeFatherName}
                    />
                    <small className="text-danger">{checkFatherName}</small>
                    </div>
                    <div className="w-100"></div>
                    <span className='form-text mt-3 ' style={{ fontFamily:'sans-serif', "color": "#13547A" , fontWeight: 600 ,"fontSize":'18px' }}>Permanent Address</span>
                    <div className="col-sm mt-3 mr-3">
                    <span className='form-text ml-3' style={{ fontFamily:'sans-serif', "color": "#000000" , fontWeight: 400 ,"fontSize":'16px' }}>Address Line 1*</span>
                      <input
                        style={{ borderRadius: "30px" }}
                        type="text"
                        className="form-control py-3 mt-1 "
                        placeholder="Enter Address"
                        onChange={changePaddress}
                    />
                    <small className="text-danger">{checkPaddressline1}</small>
                    </div>
                    <div className="col-sm mt-3 mr-3">
                    <span className='form-text ml-3' style={{ fontFamily:'sans-serif', "color": "#000000" , fontWeight: 400 ,"fontSize":'16px' }}>Address Line 2</span>
                      <input
                        style={{ borderRadius: "30px" }}
                        type="text"
                        className="form-control py-3 mt-1 "
                        placeholder="Enter City"
                        onChange={(e) => {
                              setAddData({
                                  ...addData,
                                  paddressline2: e.target.value,
                              });
                          }}
                    />
                    </div>
                <div className="w-100"></div>
                <div className="col-sm mt-3 mr-3">
                    <span className='form-text ml-3' style={{ fontFamily:'sans-serif', "color": "#000000" , fontWeight: 400 ,"fontSize":'16px' }}>Address Line 3</span>
                      <input
                        style={{ borderRadius: "30px" }}
                        type="text"
                        className="form-control py-3 mt-1 "
                        placeholder="Enter Address"
                        onChange={(e) => {
                              setAddData({
                                  ...addData,
                                  paddressline3: e.target.value,
                              });
                          }}
                    />
                    </div>
                    <div className="col-sm mt-3 mr-3">
                    <span className='form-text ml-3' style={{ fontFamily:'sans-serif', "color": "#000000" , fontWeight: 400 ,"fontSize":'16px' }}>City*</span>
                      <input
                        style={{ borderRadius: "30px" }}
                        type="text"
                        className="form-control py-3 mt-1 "
                        placeholder="Enter City"
                        onChange={changePcity}
                    />
                    <small className="text-danger">{checkPcity}</small>
                    </div>
                <div className="w-100"></div>
                
                    <div className="col-sm mt-3 mr-3">
                    <span className='form-text ml-3' style={{ fontFamily:'sans-serif', "color": "#000000" , fontWeight: 400 ,"fontSize":'16px' }}>State*</span>
                      <input
                        style={{ borderRadius: "30px" }}
                        type="text"
                        className="form-control py-3 mt-1"
                        placeholder="Enter State"
                        onChange={changePstate}
                    />
                    <small className="text-danger">{checkPstate}</small>
                    </div>
                    <div className="col-sm mt-3 mr-3">
                    <span className='form-text ml-3' style={{ fontFamily:'sans-serif', "color": "#000000" , fontWeight: 400 ,"fontSize":'16px' }}>Country*</span>
                      <input
                        style={{ borderRadius: "30px" }}
                        type="text"
                        className="form-control py-3 mt-1"
                        placeholder="Enter Country"
                        onChange={changePcountry}
                    />
                    <small className="text-danger">{checkPcountry}</small>
                    </div>
                    <div className="w-100"></div>
                    <div className="col-sm mt-3 mr-3">
                    <span className='form-text ml-3' style={{ fontFamily:'sans-serif', "color": "#000000" , fontWeight: 400 ,"fontSize":'16px' }}>Postcode*</span>
                      <input
                        style={{ borderRadius: "30px" }}
                        type="text"
                        className="form-control py-3 mt-1"
                        placeholder="Enter Postcode"
                        onChange={changePpostcode}
                    />
                    <small className="text-danger">{checkPpostcode}</small>
                    </div>
                    <div className="col-sm"></div>
                    <div className="w-100"></div>
                    <div className="col-sm mt-3 mr-3">
                        <span className='form-text mt-3 ' style={{ fontFamily:'sans-serif', "color": "#13547A" , fontWeight: 600 ,"fontSize":'18px' }}>Correspondence Address</span>
                    </div>
                    <div className="col-sm mt-3 mr-3">
                        <input type="checkbox" onClick={addressCopy} id="same_as_permanent_address" name="same_as_permanent_address" value="same_as_permanent_address" className='me-2' />
                        <label for="same_as_permanent_address" style={{ fontFamily:'sans-serif', "color": "#000000" , fontWeight: 400 ,"fontSize":'16px' }}> Same as Permanent Address</label>
                    </div>
                    <div className="w-100"></div>
                    <div className="col-sm mt-3 mr-3">
                    <span className='form-text ml-3' style={{ fontFamily:'sans-serif', "color": "#000000" , fontWeight: 400 ,"fontSize":'16px' }}>Address Line 1*</span>
                      <input
                        style={{ borderRadius: "30px" }}
                        type="text"
                        className="form-control py-3 mt-1"
                      placeholder="Enter Address"
                      onChange={changeCaddress}
                      defaultValue={addData.caddressline1}
                    />
                    <small className="text-danger">{checkCaddressline1}</small>
                    </div>
                    <div className="col-sm mt-3 mr-3">
                    <span className='form-text ml-3' style={{ fontFamily:'sans-serif', "color": "#000000" , fontWeight: 400 ,"fontSize":'16px' }}>Address Line 2</span>
                      <input
                        style={{ borderRadius: "30px" }}
                        type="text"
                        className="form-control py-3 mt-1"
                        placeholder="Enter City"
                        defaultValue={addData.caddressline2}
                        onChange={(e) => {
                                setAddData({
                                    ...addData,
                                    caddressline2: e.target.value,
                                });
                            }}
                    />
                    </div>
                <div className="w-100"></div>
                
                <div className="col-sm mt-3 mr-3">
                    <span className='form-text ml-3' style={{ fontFamily:'sans-serif', "color": "#000000" , fontWeight: 400 ,"fontSize":'16px' }}>Address Line 3</span>
                      <input
                        style={{ borderRadius: "30px" }}
                        type="text"
                        className="form-control py-3 mt-1"
                        placeholder="Enter Address"
                        defaultValue={addData.caddressline3}
                        onChange={(e) => {
                            setAddData({
                                ...addData,
                                caddressline3: e.target.value,
                            });
                        }}                      
                    />
                    </div>
                    <div className="col-sm mt-3 mr-3">
                    <span className='form-text ml-3' style={{ fontFamily:'sans-serif', "color": "#000000" , fontWeight: 400 ,"fontSize":'16px' }}>City*</span>
                      <input
                        style={{ borderRadius: "30px" }}
                        type="text"
                        className="form-control py-3 mt-1"
                        placeholder="Enter City"
                      onChange={changeCcity}
                      defaultValue={addData.ccity}
                    />
                    <small className="text-danger">{checkCcity}</small>
                    </div>
                <div className="w-100"></div>
                

                    <div className="col-sm mt-3 mr-3">
                    <span className='form-text ml-3' style={{ fontFamily:'sans-serif', "color": "#000000" , fontWeight: 400 ,"fontSize":'16px' }}>State*</span>
                      <input
                        style={{ borderRadius: "30px" }}
                        type="text"
                        className="form-control py-3 mt-1"
                        placeholder="Enter State"
                      onChange={changeCstate}
                      defaultValue={addData.cstate}
                    />
                    <small className="text-danger">{checkCstate}</small>
                    </div>
                    <div className="col-sm mt-3 mr-3">
                    <span className='form-text ml-3' style={{ fontFamily:'sans-serif', "color": "#000000" , fontWeight: 400 ,"fontSize":'16px' }}>Country*</span>
                      <input
                        style={{ borderRadius: "30px" }}
                        type="text"
                        className="form-control py-3 mt-1 "
                        placeholder="Enter Country"
                      onChange={changeCcountry}
                      defaultValue={addData.ccountry}
                    />
                    <small className="text-danger">{checkCcountry}</small>
                    </div>
                    <div className="w-100"></div>
                    <div className="col-sm mt-3 mr-3">
                    <span className='form-text ml-3' style={{ fontFamily:'sans-serif', "color": "#000000" , fontWeight: 400 ,"fontSize":'16px' }}>Postcode*</span>
                      <input
                        style={{ borderRadius: "30px" }}
                        type="text"
                        className="form-control py-3 mt-1 "
                        placeholder="Enter Postcode"
                      onChange={changeCpostcode}
                      defaultValue={addData.cpostcode}
                      />
                      <small className="text-danger">{checkCpostcode}</small>
                    </div>
                    <div className="col-sm"></div>
                    <div className="w-100"></div>
                    <div className="col-sm mt-3 mr-3">
                    <span className='form-text ml-3' style={{ fontFamily:'sans-serif', "color": "#000000" , fontWeight: 400 ,"fontSize":'16px' }}>Phone Number With Code*</span>
                      <input
                        style={{ borderRadius: "30px" }}
                        type="text"
                        className="form-control py-3 mt-1 "
                        placeholder="Enter phone number"
                        defaultValue={memberDetails.phone}
                    />
                    </div>
                    <div className="col-sm mt-3 mr-3">
                    <span className='form-text ml-3' style={{ fontFamily:'sans-serif', "color": "#000000" , fontWeight: 400 ,"fontSize":'16px' }}>Date Of Birth* </span>
                      <input
                        style={{ borderRadius: "30px" }}
                        type="date"
                        name="first_name"
                        className="form-control py-3 mt-1 "
                        placeholder="Enter Date Of Birth" 
                        onChange={changedob}
                      />
                    <small className="text-danger">{checkDob}</small>
                    </div>
                    <div className="w-100"></div>
                    <div className="col-sm mt-3 mr-3">
                    <span className='form-text ml-3' style={{ fontFamily:'sans-serif', "color": "#000000" , fontWeight: 400 ,"fontSize":'16px' }}>Pan number*</span>
                      <input
                        style={{ borderRadius: "30px" }}
                        type="text"
                        name="first_name"
                        className="form-control py-3 mt-1 "
                        placeholder="Enter Pan Number" 
                        onChange={changePannumber}
                    />
                    <small className="text-danger">{checkPannumber}</small>
                    </div>
                    <div className="col-sm mt-3 mr-3">
                    <span className='form-text ml-3' style={{ fontFamily:'sans-serif', "color": "#000000" , fontWeight: 400 ,"fontSize":'16px' }}>Email ID*</span>
                      <input
                        style={{ borderRadius: "30px" }}
                        type="text"
                        name="first_name"
                        className="form-control py-3 mt-1 "
                        placeholder="Enter Email ID"
                        defaultValue={memberEmail.email}
                    />
                    </div>
                    <div className="w-100"></div>
                    <div className="col-sm mt-3 mr-3">
                    <span className='form-text ml-3' style={{ fontFamily:'sans-serif', "color": "#000000" , fontWeight: 400 ,"fontSize":'16px' }}>Unit Number*</span>
                      <input
                        style={{ borderRadius: "30px" }}
                        type="text"
                        name="first_name"
                        className="form-control py-3 mt-1 "
                        placeholder="Enter Unit Number"
                        defaultValue={memberDetails.member_unit}
                    />
                    </div>
                    <div className="col-sm mt-3 mr-3">
                    <span className='form-text ml-3' style={{ fontFamily:'sans-serif', "color": "#000000" , fontWeight: 400 ,"fontSize":'16px' }}>Occupation*</span>
                      <input
                        style={{ borderRadius: "30px" }}
                        type="text"
                        name="first_name"
                        className="form-control py-3 mt-1 "
                        placeholder="Enter Occupation" 
                        onChange={changeOccupation}
                      />
                      <small className="text-danger">{checkOccupation}</small>
                    </div>
                    <div className="w-100"></div>
                    <div className="col-sm mt-3 mr-3">
                    <span className='form-text ml-3' style={{ fontFamily:'sans-serif', "color": "#000000" , fontWeight: 400 ,"fontSize":'16px' }}>Owner Type*</span><br />
                    <input onClick={() => { setIsOpen(false); setIsOpen2(false); setOwnertype(true); resetFunction(); resetFunction2(); clearField() }} className='mt-3' type="radio" id="single" name="owner_type" value="single" />
                      <label for="html">Single</label>
                    <input className="ml-3" onClick={() => { setIsOpen(true); setOwnertype(false) }} type="radio" id="joint" name="owner_type" value="joint" />
                      <label for="css">Joint</label><br />
                    </div>
                    <div className="col-sm"></div>
                  <div className="w-100"></div>
                  
                  {isOpen ? <>
                    <span className='form-text mt-3 ' style={{ fontFamily: 'sans-serif', "color": "#13547A", fontWeight: 600, "fontSize": '18px' }}>Joint Owner Brief Particulars are as under</span>
                    <div className="col-sm mt-3 mr-3">
                    <span className='form-text ml-3' style={{ fontFamily:'sans-serif', "color": "#000000" , fontWeight: 400 ,"fontSize":'16px' }}>Name of the Applicant*</span>
                      <input
                        style={{ borderRadius: "30px" }}
                        type="text"
                        name="first_name"
                        className="form-control py-3 mt-1"
                        placeholder="Enter Applicant Name"
                        onChange={changeJO_FirstName}
                      />
                      <small className="text-danger">{checkJO_FirstName}</small>
                    </div>
                    <div className="col-sm mt-3 mr-3">
                    <span className='form-text ml-3' style={{ fontFamily:'sans-serif', "color": "#000000" , fontWeight: 400 ,"fontSize":'16px' }}>Father’s / Husband’s Name*</span>
                    <input
                        style={{ borderRadius: "30px" }}
                        type="text"
                        className="form-control py-3 mt-1"
                        placeholder="Enter Father’s / Husband’s Name"
                        onChange={changeJO_FatherName}
                    />
                    <small className="text-danger">{checkJO_FatherName}</small>
                    </div>
                    <div className="w-100"></div>
                    <div className="col-sm mt-3 mr-3">
                    <span className='form-text mt-3 ' style={{ fontFamily:'sans-serif', "color": "#13547A" , fontWeight: 600 ,"fontSize":'18px' }}>Permanent Address</span>
                    </div>
                    <div className="col-sm mt-3 mr-3">
                    <input onClick={jop_addressCopy} type="checkbox" id="same_as_primary_applicant" name="same_as_primary_applicant" value="same_as_primary_applicant" className='me-2' />
                    <label for="same_as_primary_applicant" style={{ fontFamily:'sans-serif', "color": "#000000" , fontWeight: 400 ,"fontSize":'16px' }}> Same as Primary Applicant</label>
                    </div>
                    <div className="w-100"></div>
                    <div className="col-sm mt-3 mr-3">
                    <span className='form-text ml-3' style={{ fontFamily:'sans-serif', "color": "#000000" , fontWeight: 400 ,"fontSize":'16px' }}>Address Line 1*</span>              
                      <input
                        style={{ borderRadius: "30px" }}
                        type="text"
                        className="form-control py-3 mt-1 "
                        placeholder="Enter Address"
                        onChange={changeJO_Paddress}
                        defaultValue={addData.jo_paddressline1}
                    />
                    <small className="text-danger">{checkJO_Paddressline1}</small>
                    </div>
                    <div className="col-sm mt-3 mr-3">
                    <span className='form-text ml-3' style={{ fontFamily:'sans-serif', "color": "#000000" , fontWeight: 400 ,"fontSize":'16px' }}>Address Line 2</span>
                    <input
                        style={{ borderRadius: "30px" }}
                        type="text"
                        className="form-control py-3 mt-1"
                        placeholder="Enter City"
                        defaultValue={addData.jo_paddressline2}
                        onChange={(e) => {
                            setAddData({
                                ...addData,
                                jo_paddressline2: e.target.value,
                            });
                        }} 
                    />
                    </div>
                  <div className="w-100"></div>
                  
                  <div className="col-sm mt-3 mr-3">
                    <span className='form-text ml-3' style={{ fontFamily:'sans-serif', "color": "#000000" , fontWeight: 400 ,"fontSize":'16px' }}>Address Line 3</span>              
                      <input
                        style={{ borderRadius: "30px" }}
                        type="text"
                        className="form-control py-3 mt-1 "
                        placeholder="Enter Address"
                        defaultValue={addData.jo_paddressline3}
                        onChange={(e) => {
                            setAddData({
                                ...addData,
                                jo_paddressline3: e.target.value,
                            });
                        }} 
                    />
                    </div>
                    <div className="col-sm mt-3 mr-3">
                    <span className='form-text ml-3' style={{ fontFamily:'sans-serif', "color": "#000000" , fontWeight: 400 ,"fontSize":'16px' }}>City*</span>
                    <input
                        style={{ borderRadius: "30px" }}
                        type="text"
                        className="form-control py-3 mt-1"
                        placeholder="Enter City"
                        onChange={changeJO_Pcity}
                        defaultValue={addData.jo_pcity}
                    />
                    <small className="text-danger">{checkJO_Pcity}</small>
                    </div>
                  <div className="w-100"></div>
                  

                    <div className="col-sm mt-3 mr-3">
                    <span className='form-text ml-3' style={{ fontFamily:'sans-serif', "color": "#000000" , fontWeight: 400 ,"fontSize":'16px' }}>State*</span>
                    <input
                        style={{ borderRadius: "30px" }}
                        type="text"
                        className="form-control py-3 mt-1"
                        placeholder="Enter State"
                        onChange={changeJO_Pstate}
                        defaultValue={addData.jo_pstate}
                    />
                    <small className="text-danger">{checkJO_Pstate}</small>
                    </div>
                    <div className="col-sm mt-3 mr-3">
                    <span className='form-text ml-3' style={{ fontFamily:'sans-serif', "color": "#000000" , fontWeight: 400 ,"fontSize":'16px' }}>Country*</span>
                    <input
                        style={{ borderRadius: "30px" }}
                        type="text"
                        className="form-control py-3 mt-1 "
                        placeholder="Enter Country"
                        onChange={changeJO_Pcountry}
                        defaultValue={addData.jo_pcountry}
                    />
                    <small className="text-danger">{checkJO_Pcountry}</small>
                    </div>
                    <div className="w-100"></div>
                    <div className="col-sm mt-3 mr-3">
                    <span className='form-text ml-3' style={{ fontFamily:'sans-serif', "color": "#000000" , fontWeight: 400 ,"fontSize":'16px' }}>Postcode*</span>
                    <input
                        style={{ borderRadius: "30px" }}
                        type="text"
                        className="form-control py-3 mt-1 "
                        placeholder="Enter Postcode"
                        onChange={changeJO_Ppostcode}
                        defaultValue={addData.jo_ppostcode}
                      />
                      <small className="text-danger">{checkJO_Ppostcode}</small>
                    </div>
                    <div className="col-sm"></div>
                    <div className="w-100"></div>
                    <div className="col-sm mt-3 mr-3">
                        <span className='form-text mt-3 ' style={{ fontFamily:'sans-serif', "color": "#13547A" , fontWeight: 600 ,"fontSize":'18px' }}>Correspondence Address</span>
                    </div>
                    <div className="col-sm mt-3 mr-3">
                        <input onClick={joc_addressCopy} type="checkbox" id="same_as_permanent_address" name="same_as_permanent_address=" value="same_as_permanent_address=" className='me-2' />
                        <label for="same_as_permanent_address=" style={{ fontFamily:'sans-serif', "color": "#000000" , fontWeight: 400 ,"fontSize":'16px' }}>Same as Permanent Address</label>
                    </div>
                    <div className="w-100"></div>
                    <div className="col-sm mt-3 mr-3">
                    <span className='form-text ml-3' style={{ fontFamily:'sans-serif', "color": "#000000" , fontWeight: 400 ,"fontSize":'16px' }}>Address Line 1*</span>
                    <input
                        style={{ borderRadius: "30px" }}
                        type="text"
                        className="form-control py-3 mt-1"
                        placeholder="Enter Address"
                        onChange={changeJO_Caddress}
                        defaultValue={addData.jo_caddressline1}
                    />
                    <small className="text-danger">{checkJO_Caddressline1}</small>
                    </div>
                    <div className="col-sm mt-3 mr-3">
                    <span className='form-text ml-3' style={{ fontFamily:'sans-serif', "color": "#000000" , fontWeight: 400 ,"fontSize":'16px' }}>Address Line 2</span>
                    <input
                        style={{ borderRadius: "30px" }}
                        type="text"
                        className="form-control py-3 mt-1"
                        placeholder="Enter City"
                        defaultValue={addData.jo_caddressline2}
                        onChange={(e) => {
                            setAddData({
                                ...addData,
                                jo_caddressline2: e.target.value,
                            });
                        }}                     />
                    </div>
                    <div className="w-100"></div>

                    <div className="col-sm mt-3 mr-3">
                    <span className='form-text ml-3' style={{ fontFamily:'sans-serif', "color": "#000000" , fontWeight: 400 ,"fontSize":'16px' }}>Address Line 3</span>
                    <input
                        style={{ borderRadius: "30px" }}
                        type="text"
                        className="form-control py-3 mt-1"
                        placeholder="Enter Address"
                        defaultValue={addData.jo_caddressline3}
                        onChange={(e) => {
                            setAddData({
                                ...addData,
                                jo_caddressline3: e.target.value,
                            });
                      }}
                    />
                    </div>
                    <div className="col-sm mt-3 mr-3">
                    <span className='form-text ml-3' style={{ fontFamily:'sans-serif', "color": "#000000" , fontWeight: 400 ,"fontSize":'16px' }}>City*</span>
                    <input
                        style={{ borderRadius: "30px" }}
                        type="text"
                        className="form-control py-3 mt-1"
                        placeholder="Enter City"
                        onChange={changeJO_Ccity}
                        defaultValue={addData.jo_ccity}
                    />
                    <small className="text-danger">{checkJO_Ccity}</small>
                    </div>
                  <div className="w-100"></div>
                  

                    <div className="col-sm mt-3 mr-3">
                    <span className='form-text ml-3' style={{ fontFamily:'sans-serif', "color": "#000000" , fontWeight: 400 ,"fontSize":'16px' }}>State*</span>
                    <input
                        style={{ borderRadius: "30px" }}
                        type="text"
                        className="form-control py-3 mt-1"
                        placeholder="Enter State"
                        onChange={changeJO_Cstate}
                        defaultValue={addData.jo_cstate}
                    />
                    <small className="text-danger">{checkJO_Cstate}</small>
                    </div>
                    <div className="col-sm mt-3 mr-3">
                    <span className='form-text ml-3' style={{ fontFamily:'sans-serif', "color": "#000000" , fontWeight: 400 ,"fontSize":'16px' }}>Country*</span>
                    <input
                        style={{ borderRadius: "30px" }}
                        type="text"
                        className="form-control py-3 mt-1 "
                        placeholder="Enter Country"
                        onChange={changeJO_Ccountry}
                        defaultValue={addData.jo_ccountry}
                    />
                    <small className="text-danger">{checkJO_Ccountry}</small>
                    </div>
                    <div className="w-100"></div>
                    <div className="col-sm mt-3 mr-3">
                    <span className='form-text ml-3' style={{ fontFamily:'sans-serif', "color": "#000000" , fontWeight: 400 ,"fontSize":'16px' }}>Postcode*</span>
                    <input
                        style={{ borderRadius: "30px" }}
                        type="text"
                        className="form-control py-3 mt-1 "
                        placeholder="Enter Postcode"
                        onChange={changeJO_Cpostcode}
                        defaultValue={addData.jo_cpostcode}
                      />
                      <small className="text-danger">{checkJO_Cpostcode}</small>
                    </div>
                    <div className="col-sm"></div>
                    <div className="w-100"></div>
                    <div className="col-sm mt-3 mr-3">
                    <span className='form-text ml-3' style={{ fontFamily:'sans-serif', "color": "#000000" , fontWeight: 400 ,"fontSize":'16px' }}>Phone Number With Code*</span>
                    <input
                        style={{ borderRadius: "30px" }}
                        type="text"
                        className="form-control py-3 mt-1 "
                        placeholder="Enter phone number"
                        onChange={changeJO_Phonenumber}
                    />
                    <small className="text-danger">{checkJO_Phonenumber}</small>
                    </div>
                    <div className="col-sm mt-3 mr-3">
                    <span className='form-text ml-3' style={{ fontFamily:'sans-serif', "color": "#000000" , fontWeight: 400 ,"fontSize":'16px' }}>Date Of Birth* </span>
                    <input
                        style={{ borderRadius: "30px" }}
                        type="date"
                        name="first_name"
                        className="form-control py-3 mt-1 "
                        placeholder="Enter Date Of Birth" 
                        onChange={changeJO_dob}
                      />
                    <small className="text-danger">{checkJO_Dob}</small>
                    </div>
                    <div className="w-100"></div>
                    <div className="col-sm mt-3 mr-3">
                    <span className='form-text ml-3' style={{ fontFamily:'sans-serif', "color": "#000000" , fontWeight: 400 ,"fontSize":'16px' }}>Occupation*</span>
                    <input
                        style={{ borderRadius: "30px" }}
                        type="text"
                        name="first_name"
                        className="form-control py-3 mt-1 "
                        placeholder="Enter Occupation" 
                        onChange={changeJO_Occupation}
                      />
                      <small className="text-danger">{checkJO_Occupation}</small>
                    </div>
                    <div className="col-sm mt-3 mr-3">
                    <span className='form-text ml-3' style={{ fontFamily:'sans-serif', "color": "#000000" , fontWeight: 400 ,"fontSize":'16px' }}>Email ID*</span>
                    <input
                        style={{ borderRadius: "30px" }}
                        type="text"
                        name="first_name"
                        className="form-control py-3 mt-1 "
                        placeholder="Enter Email ID"
                        onChange={changeJO_Email}
                    />
                      <small className="text-danger">{checkJO_Email}</small>
                    </div>
                    <div className="w-100"></div>
                  
                    <div className="col-md  mt-3 mr-3">
                      <div className='row d-flex justify-content-start'>  
                        <div className='col-md col-lg-6'>                          
                          <button
                            type="button"
                            onClick={() => { setIsOpen2(true) }}
                            style={{ backgroundColor: "#13547A", borderRadius: "30px" , "color": "#ffffff" }}
                            className="btn w-100 py-3"
                            label='Submit'>
                            Add 2nd Joint Owner
                        </button>
                      </div>  
                      </div>
                    </div>
                    <div className="col-md mt-3 mr-3">
                      <div className='row d-flex justify-content-end'>  
                        <div className='col-md-5'>                          
                          <button
                            onClick={() => { resetFunction(); resetField1() }}
                            style={{ backgroundColor: "#13547A", borderRadius: "30px" , "color": "#ffffff" }}
                            className="btn w-100 py-3"
                            type='submit' label='Submit'>
                            Reset
                        </button>
                      </div>  
                      </div>
                    </div>
                    <div className="w-100"></div>
                  </> : null}

                    {isOpen2 ? <>
                    <span className='form-text mt-3 ' style={{ fontFamily: 'sans-serif', "color": "#13547A", fontWeight: 600, "fontSize": '18px' }}>Second Joint Owner Brief Particulars are as under</span>
                    <div className="col-sm mt-3 mr-3">
                    <span className='form-text ml-3' style={{ fontFamily:'sans-serif', "color": "#000000" , fontWeight: 400 ,"fontSize":'16px' }}>Name of the Applicant*</span>
                      <input
                        style={{ borderRadius: "30px" }}
                        type="text"
                        name="first_name"
                        className="form-control py-3 mt-1"
                        placeholder="Enter Applicant Name"
                        onChange={changeSJO_FirstName}
                      />
                      <small className="text-danger">{checkSJO_FirstName}</small>
                    </div>
                    <div className="col-sm mt-3 mr-3">
                    <span className='form-text ml-3' style={{ fontFamily:'sans-serif', "color": "#000000" , fontWeight: 400 ,"fontSize":'16px' }}>Father’s / Husband’s Name*</span>
                    <input
                        style={{ borderRadius: "30px" }}
                        type="text"
                        className="form-control py-3 mt-1"
                        placeholder="Enter Father’s / Husband’s Name"
                        onChange={changeSJO_FatherName}
                    />
                    <small className="text-danger">{checkSJO_FatherName}</small>
                    </div>
                    <div className="w-100"></div>
                    <div className="col-sm mt-3 mr-3">
                    <span className='form-text mt-3 ' style={{ fontFamily:'sans-serif', "color": "#13547A" , fontWeight: 600 ,"fontSize":'18px' }}>Permanent Address</span>
                    </div>
                    <div className="col-sm mt-3 mr-3">
                    <input onClick={sjop_addressCopy} type="checkbox" id="same_as_primary_applicant" name="same_as_primary_applicant" value="same_as_primary_applicant" className='me-2' />
                    <label for="same_as_primary_applicant" style={{ fontFamily:'sans-serif', "color": "#000000" , fontWeight: 400 ,"fontSize":'16px' }}> Same as Primary Applicant</label>
                    </div>
                    <div className="w-100"></div>

                    <div className="col-sm mt-3 mr-3">
                    <span className='form-text ml-3' style={{ fontFamily:'sans-serif', "color": "#000000" , fontWeight: 400 ,"fontSize":'16px' }}>Address Line 1*</span>
                    <input
                        style={{ borderRadius: "30px" }}
                        type="text"
                        className="form-control py-3 mt-1 "
                        placeholder="Enter Address"
                        onChange={changeSJO_Paddress}
                        defaultValue={addData.sjo_paddressline1}
                    />
                    <small className="text-danger">{checkSJO_Paddressline1}</small>
                    </div>
                    <div className="col-sm mt-3 mr-3">
                    <span className='form-text ml-3' style={{ fontFamily:'sans-serif', "color": "#000000" , fontWeight: 400 ,"fontSize":'16px' }}>Address Line 2</span>
                    <input
                        style={{ borderRadius: "30px" }}
                        type="text"
                        className="form-control py-3 mt-1"
                        placeholder="Enter City"
                        defaultValue={addData.sjo_paddressline2}
                        onChange={(e) => {
                            setAddData({
                                ...addData,
                                sjo_paddressline2: e.target.value,
                            });
                      }}
                    />
                    </div>
                  <div className="w-100"></div>
                  
                  <div className="col-sm mt-3 mr-3">
                    <span className='form-text ml-3' style={{ fontFamily:'sans-serif', "color": "#000000" , fontWeight: 400 ,"fontSize":'16px' }}>Address Line 3</span>
                    <input
                        style={{ borderRadius: "30px" }}
                        type="text"
                        className="form-control py-3 mt-1 "
                        placeholder="Enter Address"
                        defaultValue={addData.sjo_paddressline3}
                        onChange={(e) => {
                            setAddData({
                                ...addData,
                                sjo_paddressline3: e.target.value,
                            });
                      }}
                    />
                    </div>
                    <div className="col-sm mt-3 mr-3">
                    <span className='form-text ml-3' style={{ fontFamily:'sans-serif', "color": "#000000" , fontWeight: 400 ,"fontSize":'16px' }}>City*</span>
                    <input
                        style={{ borderRadius: "30px" }}
                        type="text"
                        className="form-control py-3 mt-1"
                        placeholder="Enter City"
                        onChange={changeSJO_Pcity}
                        defaultValue={addData.sjo_pcity}
                    />
                    <small className="text-danger">{checkSJO_Pcity}</small>
                    </div>
                  <div className="w-100"></div>
                  

                    <div className="col-sm mt-3 mr-3">
                    <span className='form-text ml-3' style={{ fontFamily:'sans-serif', "color": "#000000" , fontWeight: 400 ,"fontSize":'16px' }}>State*</span>
                    <input
                        style={{ borderRadius: "30px" }}
                        type="text"
                        className="form-control py-3 mt-1"
                        placeholder="Enter State"
                        onChange={changeSJO_Pstate}
                        defaultValue={addData.sjo_pstate}
                    />
                    <small className="text-danger">{checkSJO_Pstate}</small>
                    </div>
                    <div className="col-sm mt-3 mr-3">
                    <span className='form-text ml-3' style={{ fontFamily:'sans-serif', "color": "#000000" , fontWeight: 400 ,"fontSize":'16px' }}>Country*</span>
                    <input
                        style={{ borderRadius: "30px" }}
                        type="text"
                        className="form-control py-3 mt-1 "
                        placeholder="Enter Country"
                        onChange={changeSJO_Pcountry}
                        defaultValue={addData.sjo_pcountry}
                    />
                    <small className="text-danger">{checkSJO_Pcountry}</small>
                    </div>
                    <div className="w-100"></div>
                    <div className="col-sm mt-3 mr-3">
                    <span className='form-text ml-3' style={{ fontFamily:'sans-serif', "color": "#000000" , fontWeight: 400 ,"fontSize":'16px' }}>Postcode*</span>
                    <input
                        style={{ borderRadius: "30px" }}
                        type="text"
                        className="form-control py-3 mt-1 "
                        placeholder="Enter Postcode"
                        onChange={changeSJO_Ppostcode}
                        defaultValue={addData.sjo_ppostcode}
                      />
                      <small className="text-danger">{checkSJO_Ppostcode}</small>
                    </div>
                    <div className="col-sm"></div>
                    <div className="w-100"></div>
                    <div className="col-sm mt-3 mr-3">
                        <span className='form-text mt-3' style={{ fontFamily:'sans-serif', "color": "#13547A" , fontWeight: 600 ,"fontSize":'18px' }}>Correspondence Address</span>
                    </div>
                    <div className="col-sm mt-3 mr-3">
                        <input onClick={sjoc_addressCopy} type="checkbox" id="same_as_permanent_address" name="same_as_permanent_address=" value="same_as_permanent_address=" className='me-2' />
                        <label for="same_as_permanent_address=" style={{ fontFamily:'sans-serif', "color": "#000000" , fontWeight: 400 ,"fontSize":'16px' }}>Same as Permanent Address</label>
                    </div>
                    <div className="w-100"></div>
                    <div className="col-sm mt-3 mr-3">
                    <span className='form-text ml-3' style={{ fontFamily:'sans-serif', "color": "#000000" , fontWeight: 400 ,"fontSize":'16px' }}>Address Line 1*</span>
                    <input
                        style={{ borderRadius: "30px" }}
                        type="text"
                        className="form-control py-3 mt-1"
                        placeholder="Enter Address"
                        defaultValue={addData.sjo_caddressline1}
                        onChange={changeSJO_Caddress}
                    />
                    <small className="text-danger">{checkSJO_Caddressline1}</small>
                    </div>
                    <div className="col-sm mt-3 mr-3">
                    <span className='form-text ml-3' style={{ fontFamily:'sans-serif', "color": "#000000" , fontWeight: 400 ,"fontSize":'16px' }}>Address Line 2</span>
                    <input
                        style={{ borderRadius: "30px" }}
                        type="text"
                        className="form-control py-3 mt-1"
                        placeholder="Enter City"
                        defaultValue={addData.sjo_caddressline2}
                        onChange={(e) => {
                            setAddData({
                                ...addData,
                                sjo_caddressline2: e.target.value,
                            });
                      }}
                    />
                    </div>
                  <div className="w-100"></div>
                  
                  <div className="col-sm mt-3 mr-3">
                    <span className='form-text ml-3' style={{ fontFamily:'sans-serif', "color": "#000000" , fontWeight: 400 ,"fontSize":'16px' }}>Address Line 3</span>
                    <input
                        style={{ borderRadius: "30px" }}
                        type="text"
                        className="form-control py-3 mt-1"
                        placeholder="Enter Address"
                        defaultValue={addData.sjo_caddressline3}
                        onChange={(e) => {
                            setAddData({
                                ...addData,
                                sjo_caddressline3: e.target.value,
                            });
                      }}
                    />
                    </div>
                    <div className="col-sm mt-3 mr-3">
                    <span className='form-text ml-3' style={{ fontFamily:'sans-serif', "color": "#000000" , fontWeight: 400 ,"fontSize":'16px' }}>City*</span>
                    <input
                        style={{ borderRadius: "30px" }}
                        type="text"
                        className="form-control py-3 mt-1"
                        placeholder="Enter City"
                        onChange={changeSJO_Ccity}
                        defaultValue={addData.sjo_ccity}
                    />
                    <small className="text-danger">{checkSJO_Ccity}</small>
                    </div>
                  <div className="w-100"></div>
                  

                    <div className="col-sm mt-3 mr-3">
                    <span className='form-text ml-3' style={{ fontFamily:'sans-serif', "color": "#000000" , fontWeight: 400 ,"fontSize":'16px' }}>State*</span>
                    <input
                        style={{ borderRadius: "30px" }}
                        type="text"
                        className="form-control py-3 mt-1"
                        placeholder="Enter State"
                        onChange={changeSJO_Cstate}
                        defaultValue={addData.sjo_cstate}
                    />
                    <small className="text-danger">{checkSJO_Cstate}</small>
                    </div>
                    <div className="col-sm mt-3 mr-3">
                    <span className='form-text ml-3' style={{ fontFamily:'sans-serif', "color": "#000000" , fontWeight: 400 ,"fontSize":'16px' }}>Country*</span>
                    <input
                        style={{ borderRadius: "30px" }}
                        type="text"
                        className="form-control py-3 mt-1 "
                        placeholder="Enter Country"
                        onChange={changeSJO_Ccountry}
                        defaultValue={addData.sjo_ccountry}
                    />
                    <small className="text-danger">{checkSJO_Ccountry}</small>
                    </div>
                    <div className="w-100"></div>
                    <div className="col-sm mt-3 mr-3">
                    <span className='form-text ml-3' style={{ fontFamily:'sans-serif', "color": "#000000" , fontWeight: 400 ,"fontSize":'16px' }}>Postcode*</span>
                    <input
                        style={{ borderRadius: "30px" }}
                        type="text"
                        className="form-control py-3 mt-1 "
                        placeholder="Enter Postcode"
                        onChange={changeSJO_Cpostcode}
                        defaultValue={addData.sjo_cpostcode}
                      />
                      <small className="text-danger">{checkSJO_Cpostcode}</small>
                    </div>
                    <div className="col-sm"></div>
                    <div className="w-100"></div>
                    <div className="col-sm mt-3 mr-3">
                    <span className='form-text ml-3' style={{ fontFamily:'sans-serif', "color": "#000000" , fontWeight: 400 ,"fontSize":'16px' }}>Phone Number With Code*</span>
                    <input
                        style={{ borderRadius: "30px" }}
                        type="text"
                        className="form-control py-3 mt-1 "
                        placeholder="Enter phone number"
                        onChange={changeSJO_Phonenumber}
                    />
                    <small className="text-danger">{checkSJO_Phonenumber}</small>
                    </div>
                    <div className="col-sm mt-3 mr-3">
                    <span className='form-text ml-3' style={{ fontFamily:'sans-serif', "color": "#000000" , fontWeight: 400 ,"fontSize":'16px' }}>Date Of Birth* </span>
                    <input
                        style={{ borderRadius: "30px" }}
                        type="date"
                        name="first_name"
                        className="form-control py-3 mt-1 "
                        placeholder="Enter Date Of Birth" 
                        onChange={changeSJO_dob}
                      />
                    <small className="text-danger">{checkSJO_Dob}</small>
                    </div>
                    <div className="w-100"></div>
                    <div className="col-sm mt-3 mr-3">
                    <span className='form-text ml-3' style={{ fontFamily:'sans-serif', "color": "#000000" , fontWeight: 400 ,"fontSize":'16px' }}>Occupation*</span>
                    <input
                        style={{ borderRadius: "30px" }}
                        type="text"
                        name="first_name"
                        className="form-control py-3 mt-1 "
                        placeholder="Enter Occupation" 
                        onChange={changeSJO_Occupation}
                      />
                      <small className="text-danger">{checkSJO_Occupation}</small>
                    </div>
                    <div className="col-sm mt-3 mr-3">
                    <span className='form-text ml-3' style={{ fontFamily:'sans-serif', "color": "#000000" , fontWeight: 400 ,"fontSize":'16px' }}>Email ID*</span>
                    <input
                        style={{ borderRadius: "30px" }}
                        type="text"
                        name="first_name"
                        className="form-control py-3 mt-1 "
                        placeholder="Enter Email ID"
                        onChange={changeSJO_Email}
                    />
                      <small className="text-danger">{checkSJO_Email}</small>
                    </div>
                    <div className="w-100"></div>
                  </>:null}
                  
                    <div className="col-sm mt-3">
                    <span className='form-text ms-3' style={{ "color": "#000000" ,"fontSize":'15px'  }}>Upload Signature</span>
                    <div className="input-container mt-1">
                        <div className="input-group">
                      <input
                            className="form-control py-3 editinput"
                            type="file"
                            placeholder="document Docs"
                            aria-label="Search"
                            id="inputGroupFile01"
                            name="document"
                            accept=".pdf"
                            onChange={imageHandler}
                            required
                          />
                          <div className="w-50 editbtn text-center">
                            <label
                              className="pt-3 text-white"
                              htmlFor="inputGroupFile01"
                            >
                            PDF
                            </label>
                          </div>
                        </div>
                        {/* <small className="text-danger">{checkSignatureerror}</small> */}
                      </div>
                    </div>
                    <div className="col-md mt-3 mr-3">
                      <div className='row d-flex justify-content-end mt-4'>  
                        <div className='col-md-5'>                          
                        <button
                            onClick={() => { resetFunction2(); resetField2() }}
                            style={{ backgroundColor: "#13547A", borderRadius: "30px" , "color": "#ffffff" }}
                            className="btn w-100 py-3"
                            type="button" label='Submit'>
                            Reset
                        </button>
                      </div>  
                      </div>
                    </div>
                    <div className="w-100"></div>
                    <div className="col-sm mt-3 mr-3">
                    <span className='form-text ml-3' style={{ fontFamily:'sans-serif', "color": "#000000" , fontWeight: 400 ,"fontSize":'16px' }}>Date*</span>
                      <input
                        style={{ borderRadius: "30px" }}
                        type="date"
                        name="first_name"
                        className="form-control py-3 mt-1 "
                        placeholder="Enter Date"
                        onChange={changeDate}
                    />
                      <small className="text-danger">{checkDate}</small>
                    </div>
                    <div className="col-sm"></div>
                    <div className="w-100"></div>
                    <div className="col-sm mt-3 mr-3">
                    <span className='form-text ml-3' style={{ fontFamily:'sans-serif', "color": "#000000" , fontWeight: 400 ,"fontSize":'16px' }}>Place*</span>
                      <input
                        style={{ borderRadius: "30px" }}
                        type="text"
                        name="first_name"
                        className="form-control py-3 mt-1 "
                        placeholder="Enter Place"
                        onChange={changePlace}
                    />
                      <small className="text-danger">{checkPlace}</small>
                    </div>
                    <div className="col-sm"></div>
                    <div className="w-100"></div>
                </div>
                <div className='row d-flex justify-content-center'>
                <div className="col-md-6">
                {loadingBtn ?<button
                          disabled
                          style={{ borderRadius: "30px" , fontFamily:'sans-serif', "color": "#ffffff" , fontWeight: 500 ,"fontSize":'16px' }}
                          className="btn w-100 py-3 editbtnsubmit mt-3 mb-2 border-0"
                          type='submit' label='Submit'>
                          Saving...
                          <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      </button> : <button
                          style={{ borderRadius: "30px" , fontFamily:'sans-serif', "color": "#ffffff" , fontWeight: 500 ,"fontSize":'16px' }}
                          className="btn w-100 py-3 editbtnsubmit mt-3 mb-2 border-0"
                          type='submit' label='Submit'>
                          Save & Next
                  </button>}
                  </div>
                </div>
              </form>
            </div>
          </div>
        </main>
    </>
  );
}
